module.exports = __webpack_public_path__ + "img/foot.c212a138.svg";